<div class="custom-security-link">
    <a [routerLink]="['/contact',contactId]">View Contact</a>
    <a [routerLink]="['/activity-history', contactId]"  [queryParams]="{ ch: true }">Contact History</a>
</div>
<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <div class="global-header-section">
                <div class="svg-icon-panel">
                    <img src="../../../../assets/contacthistorytitle.svg" class="mr-1" />Import Contact History Into:&nbsp;
                    <a class="contact-cursor-pointer" (click)="gotoLink('name',contactData)">{{contactData?.firstName}} {{contactData?.lastName}}</a>
                </div>
            </div>
            <div [innerHTML]="warningMessage" [class]="messageTypeClass"></div>
            <div class="global-padding10" *ngIf="isShowHistory">
                <button type="button" [hidden]="roleFeaturePermissions?.edit == false && user?.userRole <= eUserRole.Administrator" class="btn btn-primary" (click)="confirm()">Confirm</button>
                <button type="button" class="btn btn-cancel" (click)="cancel()">Cancel</button>
            </div>
            <div class="global-body-section global-padding10">
                <div class="wraper-main-section">
                    <div class="global-card-section">
                        <div class="common-inner-header">
                            <div class="inner-header-bg">
                                <div class="inner-cards-panel header-inner-hidden">
                                    <span>From</span>
                                    <span>To</span>
                                </div>
                                <div class="inner-detail-bg">
                                    <span>Details</span>
                                </div>
                            </div>
                        </div>
                        <div class="common-inner-cards">
                            <div class="inner-cards-grid" style="align-items:flex-start">
                                <div class="inner-card-mobile">
                                    <label>From</label>
                                    <div class="mobile-view-design">
                                        <kendo-autocomplete #autocomplete [data]="contactSearchList" valueField="searchText" placeholder="Search" (valueChange)="onSelectContact($event)"
                                                            (keyup)="getSearchData($event.target.value)" *ngIf="!isShowHistory"></kendo-autocomplete>
                                        <div *ngIf="isShowHistory">
                                            <a class="contact-cursor-pointer" (click)="gotoLink('name',fromContactData)">{{fromContactData?.firstName}} {{fromContactData?.lastName}}<br /></a>
                                            <span *ngIf="(fromContactData?.companyName)">{{fromContactData?.companyName}}<br /></span>
                                            <span *ngIf="(fromContactData?.add1)">{{fromContactData?.add1}}<br /></span>
                                            <span *ngIf="(fromContactData?.add2)">{{fromContactData?.add2}}<br /></span>
                                            <span *ngIf="(fromContactData?.add3)">{{fromContactData?.add3}}<br /></span>
                                            <span *ngIf="(fromContactData?.city)">{{fromContactData?.city}},</span>
                                            <span *ngIf="(fromContactData?.state)">{{fromContactData?.state}}  </span>
                                            <span *ngIf="(fromContactData?.zip)">{{fromContactData?.zip}}  </span>
                                            <span *ngIf="(fromContactData?.country)">{{fromContactData?.country}}<br /></span>
                                            <span *ngIf="(fromContactData?.phone)">B: {{pixString(fromContactData?.phone) | phoneFormat}}<br /></span>
                                            <span *ngIf="(fromContactData?.mobile)">M: {{pixString(fromContactData?.mobile) | phoneFormat}}<br /></span>
                                            <span *ngIf="(fromContactData?.homePhone)">H: {{pixString(fromContactData?.homePhone) | phoneFormat}}<br /></span>
                                            <span *ngIf="(fromContactData?.altPhone)">O: {{pixString(fromContactData?.altPhone) | phoneFormat}}<br /></span>
                                            <span *ngIf="(fromContactData?.fax)">F: {{fromContactData?.fax}}<br /></span>
                                            <span *ngIf="(fromContactData?.email)">E: {{fromContactData?.email}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-card-mobile">
                                    <label>To</label>
                                    <div class="mobile-view-design">
                                        <div>
                                            <a class="contact-cursor-pointer" (click)="gotoLink('name',contactData)">{{contactData?.firstName}} {{contactData?.lastName}}<br /></a>
                                            <span *ngIf="(contactData?.companyName)">{{contactData?.companyName}}<br /></span>
                                            <span *ngIf="(contactData?.add1)">{{contactData?.add1}}<br /></span>
                                            <span *ngIf="(contactData?.add2)">{{contactData?.add2}}<br /></span>
                                            <span *ngIf="(contactData?.add3)">{{contactData?.add3}}<br /></span>
                                            <span *ngIf="(contactData?.city)">{{contactData?.city}},</span>
                                            <span *ngIf="(contactData?.state)">{{contactData?.state}}  </span>
                                            <span *ngIf="(contactData?.zip)">{{contactData?.zip}}  </span>
                                            <span *ngIf="(contactData?.country)">{{contactData?.country}}<br /></span>
                                            <span *ngIf="(contactData?.phone)">B: {{pixString(contactData?.phone) | phoneFormat}}<br /></span>
                                            <span *ngIf="(contactData?.mobile)">M: {{pixString(contactData?.mobile) | phoneFormat}}<br /></span>
                                            <span *ngIf="(contactData?.homePhone)">H: {{pixString(contactData?.homePhone) | phoneFormat}}<br /></span>
                                            <span *ngIf="(contactData?.altPhone)">O: {{pixString(contactData?.altPhone) | phoneFormat}}<br /></span>
                                            <span *ngIf="(contactData?.fax)">F: {{contactData?.fax}}<br /></span>
                                            <span *ngIf="(contactData?.email)">E: {{contactData?.email}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="isShowHistory">
                <activity-history [ownerId]="fromContactId" (NoContactHistoryData)="NoContactHistoryData($event)" [isShowLinks]="false" ownerName="{{fromContactData?.firstName}} {{fromContactData?.lastName}}" [isShowContactHistory]="true"></activity-history>
            </div>
            <div class="cards-body-section">
                <div class="cards-colunm-left bg-warning text-white">
                    <span class="">Important Note</span>
                </div>
                <div class="cards-colunm-right" style="background:#fde8af">
                    <ul>
                        <li>Only contact related history items will be imported.</li>
                        <li>History items cannot be imported from a contact currently associated automated processes.</li>
                    </ul>
                </div>
            </div>  
        </div>
    </div>
</div>

